import * as ProviderOrganizationPreference from './models/providerOrganizationPreference';

import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(
    providerOrganizationPreferenceId: string,
  ): Promise<ProviderOrganizationPreference.ProviderOrganizationPreference[]> {
    const url = this.common.constructPath(
      `/provider-organization-preferences/${providerOrganizationPreferenceId}`,
    );
    return this.common.getJSON(url);
  }

  async findAll(query: {
    organizationId?: string;
    providerUserId?: string;
  }): Promise<ProviderOrganizationPreference.ProviderOrganizationPreference[]> {
    const url = this.common.constructPath(
      `/provider-organization-preferences`,
      query,
    );
    return this.common.getJSON(url);
  }

  async upsert(
    values: ProviderOrganizationPreference.BaseProviderOrganizationPreference,
  ): Promise<ProviderOrganizationPreference.ProviderOrganizationPreference> {
    const url = this.common.constructPath(`/provider-organization-preferences`);
    return this.common.putJSON(url, values);
  }
}
